<template>
    <div>
        <template v-if="$i18n.locale === 'ko'"> 
            <div class="terms-of-use-text">
                <h3>{{ $t(`제1장 [총칙]`) }}</h3>
                <h5>{{ $t(`제1조 [목적]`) }}</h5>
                <p>
                    {{
                        $t(`본 이용약관은 ㈜퀀티파이드이에스지(이하 “QESG”)가 운영하는 온라인 플랫폼 TierZero(이하 “당 사이트”)에서 제공하는 서비스 이용을 위한 회원의 권리와 의무, 책임사항, 그 밖에 필요한 기본적인 사항을 규정함을 목적으로 합니다.`)
                    }}<br>
                </p>
                <h5>{{ $t(`제2조 [용어의 정의]`) }}</h5>
                <p>
                    {{ $t(`본 약관에서 정의하는 용어는 다음과 같으며 정의되지 않은 약관상 용어의 의미는 관련 법령 및 일반적인 관행에 의하기로 합니다.`) }}<br>
                </p>
                <div class="terms-of-use-details">
                    1. "{{ $t(`이용자`) }}"{{ $t(`라 함은 당 사이트에 접속하여 이 약관에 따라 당 사이트가 제공하는 서비스를 받는 회원을 말합니다.`) }}<br>
                    2. "{{ $t(`회원`) }}"{{ $t(`이라 함은 서비스를 이용하기 위하여 당 사이트에 개인정보를 제공하여 아이디(ID)와 비밀번호를 부여 받은 자를 말합니다.`) }}<br>
                    3. "{{ $t(`계정`) }}"{{ $t(`이란 당 사이트에 가입된 회원 별 권한을 의미합니다.`) }}<br>
                    4. "{{ $t(`회원 아이디(ID)`) }}"{{ $t(`라 함은 회원의 식별 및 서비스 이용을 위하여 자신이 선정한 문자 및 숫자의 조합을 말합니다.`) }}<br>
                    5. "{{ $t(`비밀번호`) }}"{{
                        $t(`라 함은 회원이 자신의 개인정보 및 직접 작성한 콘텐츠의 보호를 위하여 선정한 문자, 숫자 및 특수문자의 조합을 말합니다.`)
                    }}<br>
                    6. "{{ $t(`가입`) }}"{{
                        $t(`이라 함은 회원가입 시 제공하는 신청서 양식에 해당 정보를 기입하고, 본 약관에 동의하여 서비스 이용계약을 완료하는 행위를 말합니다.`)
                    }}<br>
                    7. "{{ $t(`소유권`) }}"{{ $t(`이란 데이터 상품의 판매를 통해 수익을 발생시킬 수 있는 권리를 의미하며 ‘소유권자’란 해당 권리를 가진 자를 의미합니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제3조 [약관의 명시 및 개정]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 당 사이트는 본 약관의 내용을 회원이 알 수 있도록 당 사이트의 초기 화면 또는 연결된 페이지를 통해 공지합니다.`) }}<br>
                    {{
                        $t(`2. 당 사이트가 약관을 개정할 경우에는 적용일자 및 개정 사유를 명시하여 현행 약관과 함께 당 사이트의 초기화면 또는 초기화면과의 연결화면에 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.`)
                    }}
                    {{ $t(`다만, 회원에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.`) }}
                    {{ $t(`이 경우 당 사이트는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.`) }}<br>
                    {{
                        $t(`3. 당 사이트가 전항에 따라 개정약관을 공지하면서 “개정일자 적용 이전까지 회원이 명시적으로 거부 의사 표시를 하지 않는 경우 회원이 개정약관에 동의한 것으로 봅니다.”라는 취지를 명확하게 공지하였음에도 회원이 명시적으로 거부의 의사 표시를 하지 않는 경우 개정약관에 동의한 것으로 봅니다.`)
                    }}
                    {{ $t(`회원이 개정약관에 동의하지 않는 경우 당 사이트 이용계약을 해지할 수 있습니다.`) }}<br>
                    {{ $t(`4. 본 약관에 명시되지 않은 사항은 「약관의 규제에 관한 법률」 등 관계법령의 규정이 적용됩니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제4조 [약관 외 준칙]`) }}</h5>
                <div class="terms-of-use-details">
                    {{
                        $t(`약관에서 규정하지 않은 사항에 관해서는 약관의 규제 등에 관한 법률, 정보통신망 이용 촉진 및 정보보호 등에 관한 법률, 개인정보 보호법, 전기통신기본법, 전기통신사업법 등의 관계법령에 따라 규율됩니다.`)
                    }}<br>
                    <br>
                    {{ $t(`회원이 유료 서비스를 구입함에 있어 유료 서비스 이용조건에 관하여 별도로 약정하는 경우, 본 약관에 우선하여 해당 약정이 적용됩니다.`) }}
                    {{ $t(`그 밖에 회사가 운영하는 개별 서비스 이용약관이 별도로 있는 경우 해당 서비스 이용약관이 본 약관에 우선하여 적용됩니다.`) }}<br>
                    <br>
                    {{
                        $t(`회원이 회사와 개별 계약을 체결하여 서비스를 이용하는 경우, 개인회원의 서비스 이용과 관련된 권리 의무는 순차적으로 개별 계약, 개별 서비스 이용약관, 본 약관에서 정한 내용에 따라 규율됩니다.`)
                    }}<br>
                </div>
                <br>
                <br>

                <h3>{{ $t(`제2장 회원가입`) }}</h3>
                <h5>{{ $t(`제5조 [이용계약의 성립]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`이용계약은 고객이 당 사이트가 제공하는 양식에 따라 회원가입 신청 시, 당 사이트가 정한 약관에 동의함을 선택하고, 당 사이트가 이를 승낙함으로써 성립합니다.`) }}<br>
                    {{
                        $t(`당 사이트는 고객의 회원가입을 위하여 이메일, 이름, 비밀번호 정보 외에도 회원에게 다양하고 유익한 정보를 제공하기 위하여 이용신청자에게 메일수신여부를 요청할 수 있습니다. 이는 당 사이트의 개인정보 처리방침에 따라 사용됩니다. 다만, 신청자는 그러한 정보의 제공을 거절할 수 있습니다.`)
                    }}<br>
                </div>
                <br>
                <h5>{{ $t(`제6조 [회원가입]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`당 사이트가 제공하는 서비스를 이용하고자 하는 고객은 당 사이트가 제공하는 가입신청양식에 따라 가입신청을 해야 합니다.`) }}<br>
                    {{ $t(`가입신청 시 필요한 정보는 사실대로 기재하여야 합니다.`) }}<br>
                </div>
                <br>
                <br>

                <h5>{{ $t(`제7조 [개인정보의 보호]`) }}</h5>
                <p>
                    {{ $t(`당 사이트는 관계법령이 정하는 바에 따라 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위해 노력합니다.`) }}<br>
                    {{ $t(`회원의 개인정보는 개인정보보호법에 의해 보호되며, 당 사이트의 개인정보 처리방침이 적용됩니다.`) }}<br>
                    {{ $t(`다만, 당 사이트 이외에 링크된 사이트에 대해서는 당 사이트의 개인정보 보호정책이 적용되지 않습니다.`) }}<br>
                </p>
                <br>
                <br>

                <h5>{{ $t(`제8조 [이용 신청의 승낙과 제한]`) }}</h5>
                <p>
                    {{ $t(`당 사이트는 제5조의 규정에 의한 화원가입 고객에 대하여 약관에 정하는 바에 따라 서비스 이용을 승낙합니다.`) }}<br>
                    {{ $t(`당 사이트는 아래사항에 해당하는 경우에 대해서 회원가입을 승낙하지 아니하거나 이후 사전 통보 없이 취소할 수 있습니다.`) }}<br>
                </p>
                <div class="terms-of-use-details">
                    1. {{ $t(`실명이 아니거나 타인의 명의를 이용한 경우`) }}<br>
                    2. {{ $t(`허위의 정보를 기재하거나, 당 사이트가 제시하는 내용을 기재하지 않은 경우`) }}<br>
                    3. {{ $t(`가입신청자의 귀책사유로 인하여 승인이 불가능한 경우`) }}<br>
                    4. {{ $t(`당 사이트로부터 자격정지 조치 등을 받은 회원이 그 조치 기간 중에 이용계약을 임의 해지하고 재이용 신청을 하는 경우`) }}<br>
                    5. {{ $t(`기타 본 약관에 위배되거나 위법 또는 부당한 이용신청임이 확인된 경우 및 당 사이트의 합리적인 판단에 의하여 필요하다고 인정하는 경우`) }}<br>
                    6. {{ $t(`다른 사람의 당 사이트 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 경우`) }}<br>
                    7. {{ $t(`당 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우`) }}
                </div>
                <br>
                <br>

                <h3>{{ $t(`제3장 [서비스 이용]`) }}</h3>
                <h5>{{ $t(`제9조 [서비스 이용 시간]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 회원의 이용신청을 승낙한 때부터 서비스를 개시합니다.`) }} {{ $t(`단, 일부 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다.`) }}<br>
                    {{ $t(`2. 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공시하거나 회원에게 이를 통지합니다.`) }}<br>
                    {{
                        $t(`3. 서비스의 이용은 연중무휴, 1일 24시간을 원칙으로 하며, 서비스 응대 및 처리 시간은 법정 근무일 근무시간(09:00~18:00, 법정공휴일 및 주말 제외)으로 합니다.`)
                    }}
                    {{ $t(`다만, 당 사이트의 업무상 또는 기술상의 이유로 서비스가 일시 중지될 수 있습니다.`) }}
                    {{ $t(`이러한 경우 당 사이트는 사전 또는 사후에 이를 공지합니다.`) }}<br>
                    {{ $t(`4. 회원으로 가입한 이후라도 일부 서비스 이용 시 특정회원에게만 서비스를 제공할 수 있습니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제10조 [서비스 저작권]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 당 사이트가 게시한 모든 콘텐츠에 대한 저작권은 당 사이트에 있습니다.`) }}
                    {{ $t(`다만, 게시물의 원저작자가 별도로 있는 경우 그 출처를 명시하며 해당 게시물의 저작권은 원저작자에게 있습니다.`) }}<br>
                    {{ $t(`2. 회원이 직접 게시한 저작물의 저작권은 회원에게 있습니다.`) }}
                    {{ $t(`다만, 회원은 당 사이트에 무료로 이용할 수 있는 권리를 허락한 것으로 봅니다.`) }}<br>
                    {{ $t(`3. 당 사이트 소유의 콘텐츠에 대하여 제3자가 허락 없이 다른 홈페이지에 사용 또는 인용하는 것을 금지합니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제11조 [서비스의 중지 및 정보의 저장과 사용]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 당 사이트는 기술상, 운영상의 필요에 의해 제공하는 서비스의 일부 또는 전부를 변경하거나 중단할 수 있습니다.`) }}
                    {{
                        $t(`당 사이트의 서비스를 일시적으로 중단하는 경우에는 7일 전에 당 사이트 또는 이메일을 통해 이를 공지하되, 다만 사전에 통지할 수 없는 부득이한 사정이 있는 경우는 사후에 통지를 할 수 있습니다.`)
                    }}<br>
                    {{ $t(`2. 제1항의 경우에 당 사이트가 제공하는 서비스의 이용과 관련하여, 당 사이트는 이용자에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다.`) }}
                    {{ $t(`다만 당 사이트의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.`) }}<br>
                    {{
                        $t(`3. 당 사이트에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, 당 사이트의 관리 범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 당 사이트는 관련 책임을 부담하지 아니합니다.`)
                    }}<br>
                    {{
                        $t(`4. 당 사이트가 정상적인 서비스 제공의 어려움으로 인하여 서비스 영구히 중지하여야 할 경우에는 서비스 중지 30일 전의 고지 후 서비스를 중지할 수 있으며, 이 기간 동안 이용자가 고지내용을 인지하지 못한 데 대하여 당 사이트는 책임을 부담하지 아니합니다.`)
                    }}
                    {{ $t(`부득이한 사정이 있을 경우 위 사전 고지기간은 감축되거나 생략될 수 있습니다.`) }}
                    {{
                        $t(`또한 위 서비스 중지에 의하여 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나 삭제, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 당 사이트는 책임을 부담하지 아니합니다.`)
                    }}<br>
                    {{ $t(`5. 당 사이트는 사전 고지 후 서비스를 일시적으로 수정, 변경 및 중단할 수 있으며, 이에 대하여 이용자 또는 제3자에게 어떠한 책임도 부담하지 아니합니다.`) }}<br>
                    {{ $t(`6. 장기간 휴면 이용자인 경우 안내 메일 또는 공지사항 발표 후 1주일간의 통지 기간을 거쳐 서비스 사용을 중지할 수 있습니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제12조 [서비스 이용계약의 종료]`) }}</h5>
                <div class="terms-of-use-details">
                    {{
                        $t(`1. 회원은 언제든지 고객센터(info@qesg.co.kr)을 통하여 이용계약 해지 신청을 할 수 있으며, 당 사이트는 최대한 빠른 시일 내에 이를 처리하여야 합니다.`)
                    }}<br>
                    {{ $t(`2. 회원이 계약을 해지할 경우, 관련법령 및 개인정보 처리방침에 따라 당 사이트가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터가 소멸됩니다.`) }}
                    <br>
                    {{ $t(`3. 회원이 계약을 해지하는 경우, 회원이 작성한 게시물 등은 삭제되지 않습니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제13조 [서비스의 요금]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 회사는 유료서비스의 이용요금을 사이트 등에 게시하여 공지합니다.`) }}<br>
                    {{
                        $t(`2. 회사는 유료서비스 이용금액을 변경할 수 있으며, 정기결제 서비스의 경우 이용요금 변경시 변경된 이용요금 내용 및 변경 내용 적용일을 명시하여 변경 내용 적용일 7일전 또는 관련 법률에서 정한 기한 전까지 회원에게 사전 공지합니다.`)
                    }}<br>
                    {{
                        $t(`3. 공지된 이용요금 변경 내용은 변경 내용 적용일부터 모든 개인회원에게 적용됩니다. 다만, 이용요금 변경 내용 적용일 이전에 체결된 계약금액에 영향을 미치지 아니합니다.`)
                    }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제14조 [이용요금의 환불]`) }}</h5>
                <div class="terms-of-use-details">
                    {{ $t(`1. 본 조가 적용되는 당사 유료 제품 및 서비스는 아래와 같습니다.`) }}<br>
                    <br>
                    <!--                {{ $t(`① (무형상품) Tierzero 유료 계정 서비스: 당사 ESG 평가 서비스 Tierzero 플랫폼을 통해 제공되는 유료 계정 서비스`) }}<br>-->
                    <!--                <a href="http://assessment.qesg.co.kr">http://assessment.qesg.co.kr</a><br>-->
                    <!--                <br>-->
                    {{ $t(`① (무형상품) Tierzero 평가 신청권: 당사 ESG 평가 서비스인 Tierzero 신청 쿠폰`) }}<br>
                    <br>
                    {{ $t(`2. 제14조 1항에서 규정한 무형상품은 결제 완료 즉시 상품이 제공되므로 배송 및 결제 취소 절차가 생략됩니다.`) }}<br>
                    <br>
                    {{ $t(`3. 무형 상품의 신청 내용을 환불하고자 할 때에는 회원 본인이 직접 메일 또는 전화 등을 통해 신청하여야 합니다.`) }}<br>
                    <br>
                    {{ $t(`4. 무형상품 환불 조건`) }}<br>
                    <table border="1" cellspacing="0" cellpadding="5">
                        <tr>
                            <th>{{ $t('구분') }}</th>
                            <th>{{ $t('조건') }}</th>
                            <th>{{ $t('환불계산방식') }}</th>
                        </tr>
                        <!--                    <tr>-->
                        <!--                        <td rowspan="2">{{ $t('유료계정서비스') }}</td>-->
                        <!--                        <td>{{ $t('결제 7일 이내, 이용 내역 없을 경우') }}</td>-->
                        <!--                        <td>{{ $t('전액 환불') }}</td>-->
                        <!--                    </tr>-->
                        <!--                    <tr>-->
                        <!--                        <td>{{ $t('결제 7일 초과 또는 이용 내역* 있을 경우') }}</td>-->
                        <!--                        <td>{{ $t('서비스 제공사 정책에 따라 환불 불가') }}</td>-->
                        <!--                    </tr>-->
                        <tr>
                            <td rowspan="2">{{ $t('평가 신청권') }}</td>
                            <td>{{ $t('결제 7일 이내, 평가권(코드) 등록 이전') }}</td>
                            <td>{{ $t('전액 환불') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('결제 7일 초과 또는 평가권(코드) 등록 이후') }}</td>
                            <td>{{ $t('서비스 제공사 정책에 따라 환불 불가') }}</td>
                        </tr>
                    </table>
                    {{ $t('*유료계정만 접근 가능한 서비스에 진입한 전산적 기록을 통해 확인') }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제15조 [정보 제공 및 홍보물 게재]`) }}</h5>
                <div class="terms-of-use-details">
                    1. {{ $t(`당 사이트는 서비스를 운영함에 있어서 각종 정보를 당 사이트에 게재하는 방법 등을 통해 회원에게 제공할 수 있습니다.`) }}<br>
                    2. {{ $t(`당 사이트는 서비스에 적절하다고 판단하거나 활용 가능성 있는 홍보물을 게재할 수 있습니다.`) }}
                </div>
                <br>
                <br>

                <h5>{{ $t(`제16조 [회사의 의무]`) }}</h5>
                <div class="terms-of-use-details">
                    1. {{ $t(`회사는 지속적이고 안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.`) }}<br>
                    2. {{
                        $t(`회사는 회원의 개인 신상 정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다. 다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.`)
                    }}<br>
                    3. {{ $t(`회사는 회원으로부터 제기되는 의견이 합당하다고 판단될 경우에는, 적절한 조치를 취하여야 합니다.`) }}<br>
                    4. {{ $t(`회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.`) }}<br>
                    5. {{
                        $t(`회사는 천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여 서비스가 중단될 경우 이에 대한 손해에 대해서는 책임을 지지 않습니다. 다만 자료의 복구나 정상적인 서비스 지원이 되도록 최선을 다할 의무를 부담합니다.`)
                    }}<br>
                    6. {{ $t(`회사는 유료 결제와 관련한 결제사항 정보를 5년간 보존합니다.`) }}<br>
                </div>
                <br>
                <br>
                <h5>{{ $t(`제17조 [이용자의 의무]`) }}</h5>
                <div class="terms-of-use-details">
                    1. {{
                        $t(`이용자는 관계법령과 본 약관의 규정, 회사의 서비스 운영정책 기타 고지된 서비스 이용상의 유의 사항을 준수하여야 하며, 기타 회사의 업무에 지장을 초래하는 행위를 하여서는 아니됩니다.`)
                    }}<br>
                    2. {{
                        $t(`이용자가 신청한 유료서비스는 등록 또는 신청과 동시에 회사와 채권, 채무 관계가 발생하며, 이용자는 이용요금을 회사가 지정한 기일 내에 납부하여야 합니다.`)
                    }}<br>
                    3. {{
                        $t(`이용자가 결제 수단으로 신용카드를 사용할 경우 비밀번호 등의 관리책임은 이용자에게 있습니다. 단, 사이트의 결함에 따른 정보유실의 발생에 대한 책임은 이용자가 부담하지 않습니다.`)
                    }}<br>
                    4. {{
                        $t(`이용자는 당 사이트의 서비스를 이용하여 얻은 정보를 각 사이트의 사전승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다. 단, 개별사이트에서 별도로 정하는 경우에는 예외로 합니다.`)
                    }}<br>
                    5. {{ $t(`이용자는 당 사이트 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안 됩니다.`) }}<br>
                    <br>
                    <div class="sub-details">
                        ① {{ $t(`다른 회원의 ID를 부정 사용하는 행위`) }}<br>
                        ② {{ $t(`범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위`) }}<br>
                        ③ {{ $t(`타인의 명예를 훼손하거나 모욕하는 행위`) }}<br>
                        ④ {{ $t(`타인의 지적재산권 등의 권리를 침해하는 행위`) }}<br>
                        ⑤ {{ $t(`해킹행위 또는 컴퓨터바이러스의 유포행위`) }}<br>
                        ⑥ {{ $t(`서비스의 안전적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위`) }}<br>
                        ⑦ {{ $t(`당 사이트의 정보 및 서비스를 이용한 영리 행위`) }}<br>
                        ⑧ {{ $t(`기타 전기통신법 제53조와 전기통신사업법 시행령 16조(불온통신), 통신사업법 제53조 3항에 위배되는 행위`) }}<br>
                    </div>

                </div>
                <br>
                <br>

                <h3>{{ $t(`제4장 [기타]`) }}</h3>
                <h5>{{ $t(`제18조 [당 사이트의 소유권]`) }}</h5>
                <p>
                    {{
                        $t(`당 사이트가 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스 명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타 권리는 당 사이트에 소유권이 있습니다.`)
                    }}<br>
                    {{
                        $t(`이용자는 명시적으로 승인받거나 개별 사이트에서 별도로 정하는 경우를 제외하고는 제1항의 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.`)
                    }}<br>
                </p>
                <br>

                <h5>{{ $t(`제19조 [손해배상]`) }}</h5>
                <p>
                    {{
                        $t(`회사가 제16조 등의 규정에 위반한 행위로 회원에게 손해를 입히거나 기타 회사가 제공하는 서비스와 관련하여 회사의 책임 있는 사유로 인해 회원에게 손해가 발생한 경우, 회사는 그 손해를 배상하여야 합니다.`)
                    }}<br>
                    <br>
                    {{
                        $t(`회원이 본 약관의 제17조 등의 규정에 위반한 행위로 회사 및 제3자에게 손해를 입히거나 개인 또는 기업 회원의 책임 있는 사유에 의해 호사 및 제3자에게 손해를 입힌 경우 회원은 그 손해를 배상하여야 합니다.`)
                    }}<br>
                </p>

                <br>
                <h5>{{ $t(`20조 [관할법원]`) }}</h5>
                <p>
                    {{ $t(`서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 민사 소송법상의 관할 법원에 제기합니다.`) }}<br>
                </p>

                <br>
                <h5>{{ $t(`부칙`) }}</h5>
                <p>
                    {{ $t(`[시행일] 본 약관은 2020년 8월 20일부터 시행됩니다.`) }}<br>
                    <br>
                    {{ $t(`[변경일] 본 약관은 2022년 4월 4일 변경됩니다.`) }}<br>
                    <br>
                    {{ $t(`[시행일]  본 약관은 2022년 4월 4일부터 시행됩니다.`) }}<br>
                    {{ $t(`개정된 약관의 적용일자 이전 이용자 또는 회원은 개정된 이용약관의 적용을 받습니다.`) }}<br>
                </p>
                <br>
                <br>

                <div class="extra">
                    <span class="title">{{ $t('별첨 1. 웹서비스의 범위') }}</span>
                    <p>- QESG Website: <a href="http://qesg.co.kr">http://qesg.co.kr</a> {{$t('및 그 서브 도메인')}}</p>
                    <p>- QESG Assessment: <a href="http://assessment.qesg.co.kr">http://assessment.qesg.co.kr</a></p>
                    <p>- TierZero: <a href="http://tierzero.kr">http://tierzero.kr</a> {{$t('및 그 서브 도메인')}}</p>
                    <p>- QESG Board: <a href="http://board.qesg.co.kr">http://board.qesg.co.kr</a></p>
                </div>
            </div>
        
        </template>
        <template v-else>
            <div class="terms-of-use-text">
                <h3>Chapter 1. General Provisions</h3>
                <h5>Article 1 [Purpose]</h5>
                <p>
                    These Terms of Use aim to define the basic provisions concerning the rights, obligations, and responsibilities of members using the services provided by QuantifiedESG Inc. (“the Company”) through its web services (collectively referred to as “the Site,” see Appendix 1).
                    <br>
                </p>
                <h5>Article 2 [Definitions]</h5>
                <p>
                    The following terms are defined as follows. Undefined terms follow relevant laws or general practices:<br>
                </p>
                <p>
                    1. “User” refers to a registered member accessing and using the Site’s services.<br>
                    2. “Member” is an individual who provides personal information, receives an ID and password, and uses services accordingly.<br>
                    3. “Account” means the access rights granted to each registered member.<br>
                    4. “User ID” refers to the combination of letters and numbers selected by the member for identification and service use.<br>
                    5. “Password” is a combination of letters, numbers, and symbols selected by the member for data protection.<br>
                    6. “Sign-up” means completing the registration form and agreeing to these terms to establish a service contract.<br>
                    7. “Ownership” refers to the rights to generate revenue from data products; the “Owner” holds such rights.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 3 [Posting and Amendments of Terms]</h5>
                <p>
                    1. These Terms will be posted on the Site’s main or linked pages for member visibility.<br>
                    2. Amendments will be announced with effective dates and reasons at least 7 days in advance (30 days for unfavorable changes).<br>
                    3. Unless members explicitly reject the amended Terms before the effective date, they will be deemed to have accepted them.<br>
                    4. Matters not specified herein are governed by relevant laws, such as the Act on the Regulation of Terms and Conditions.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 4 [Supplementary Rules]</h5>
                <p>
                    Matters not provided in these Terms follow applicable laws including the Telecommunications Business Act, Personal Information Protection Act, etc.<br>
                    <br>
                    Separate agreements or specific terms for paid services shall override these Terms in case of conflict.<br>
                </p>
                <br>
                <br>
                
                <h3>Chapter 2. Membership</h3>
                <h5>Article 5 [Establishment of Use Agreement]</h5>
                <p>
                    The agreement is formed when a customer consents to the Terms while filling out the membership form and the Site approves the registration.<br>
                    Optional email subscription may be requested to provide beneficial information.<br>
                </p>
                <br>
                <br>

                <h5>Article 6 [Membership Registration]</h5>
                <p>
                    Users must fill out the registration form truthfully.
                </p>
                <br>
                <br>
                
                <h5>Article 7 [Personal Information Protection]</h5>
                <p>
                    The Site protects personal information according to the Personal Information Protection Act and its own privacy policy.<br>
                    Linked external sites are not covered by this policy.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 8 [Approval and Restrictions]</h5>
                <p>
                    The Site may reject or revoke membership in the following cases:
                </p>
                <div class="terms-of-use-details">
                    1.	Use of a false name or another person’s identity<br>
                    2.	Submission of false or incomplete information<br>
                    3.	Inability to approve due to applicant’s fault<br>
                    4.	Attempted re-registration during suspension period<br>
                    5.	Violation of Terms or legal misuse<br>
                    6.	Disruption of others’ service use<br>
                    7.	Use of the Site for unlawful purposes<br>
                </div>
                <br>
                <br>
                
                <h3>Chapter 3. Use of Services</h3>
                <h5>Article 9 [Service Hours]</h5>
                <p>
                    1.	Services begin upon approval, except for those starting on a designated date.<br>
                    2.	Delays due to operational/technical issues will be notified.<br>
                    3.	Services are available 24/7. Responses are handled on business days from 9:00 to 18:00 (excluding holidays and weekends).<br>
                    4.	Some services may be restricted to specific members.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 10 [Copyright]</h5>
                <p>
                    1.	All content on the Site is owned by the Site, unless otherwise credited.<br>
                    2.	Members retain copyrights to their own posts, but grant the Site a free license to use them.<br>
                    3.	Unauthorized use or citation of the Site’s content is prohibited.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 11 [Service Suspension and Data Use]</h5>
                <p>
                    1.	The Site may change or suspend services with 7 days’ prior notice.<br>
                    2.	The Site is not liable for user damages except in cases of intentional or gross negligence.<br>
                    3.	Data loss due to force majeure (e.g., national emergencies, power outages) is not the Site’s responsibility.<br>
                    4.	If the service is permanently discontinued, a 30-day prior notice will be given.<br>
                    5.	The Site may modify or suspend services temporarily with prior notice.<br>
                    6.	Dormant accounts may be suspended after a 7-day notice.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 12 [Termination of Agreement]</h5>
                <p>
                    1.	Members may cancel the agreement at any time via info@qesg.co.kr.<br>
                    2.	Upon termination, all data is deleted unless retention is legally required.<br>
                    3.	Member-created posts will not be automatically deleted.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 13 [Service Fees]</h5>
                <p>
                    1.	Fees for paid services are posted on the Site.<br>
                    2.	Changes to fees will be announced at least 7 days in advance.<br>
                    3.	New fees apply from the effective date and do not affect prior contracts.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 14 [Refund Policy]</h5>
                <div class="terms-of-use-details">
                    1. Applies to:<br>
                    <div class="sub-details2">
                        ① (Digital Product) Tierzero Participation Right:<br>
                        A one-time authorization to participate in our ESG assessment service via the Tierzero platform.
                    </div>
                   
                    2. Products are delivered immediately after payment; no cancellation process is required<br>
                    3. Refund requests must be submitted directly by the member.<br>
                    4. Conditions:<br>
                    <div class="sub-details2">
                        ① Tierzero Participation Right: Full refund if unused and unregistered within 7 days. Otherwise non-refundable.<br>
                        ② Usage is confirmed through system access logs.<br>
                    </div>
                </div>
                <br>
                <br>
                
                <h5>Article 15 [Information and Promotions]</h5>
                <p>
                    1.	The Site may provide information via posts or emails.<br>
                    2.	Promotional materials may be displayed.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 16 [Company Obligations]</h5>
                <p>
                    1.	The Company strives to provide continuous and stable services.<br>
                    2.	Personal information will not be shared without consent, unless legally required.<br>
                    3.	Reasonable user feedback will be addressed.<br>
                    4.	The Company is not liable for service issues caused by users.<br>
                    5.	The Company is not liable for force majeure-related service failures but will attempt recovery.<br>
                    6.	Payment records are kept for 5 years.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 17 [User Obligations]</h5>
                <div class="terms-of-use-details">
                    1.	Users must comply with laws, these Terms, and notices.<br>
                    2.	Payment obligations arise upon registration or purchase.<br>
                    3.	Users are responsible for managing payment credentials.<br>
                    4.	Information from the Site may not be used without permission.<br>
                    5.	Prohibited acts include:<br>
                    <br>
                    <div class="sub-details">
                        ① Misuse of other users’ IDs<br>
                        ② Illegal or criminal activity<br>
                        ③ Defamation or infringement of rights<br>
                        ④ Hacking or virus distribution<br>
                        ⑤ Disrupting service operation<br>
                        ⑥ Commercial use of content<br>
                        ⑦ Violations of telecommunications laws<br>
                    </div>

                </div>
                <br>
                <br>
                
                <h3>Chapter 4. Miscellaneous</h3>
                <h5>Article 18 [Site Ownership]</h5>
                <p>
                    All intellectual property related to the Site—including software, images, logos, names, and data—belongs to the Site.<br>
                    Without explicit permission, users may not modify, distribute, sublicense, or commercially exploit the content.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 19 [Liability for Damages]</h5>
                <p>
                    The Company compensates members for damages arising from its own intentional or negligent actions.<br>
                    Users are liable for damages caused by violating these Terms.<br>
                </p>
                <br>
                <br>
                
                <h5>Article 20 [Jurisdiction]</h5>
                <p>
                    Disputes arising from the use of the service will be resolved by the competent court under the Civil Procedure Act.
                </p>
                <br>
                <br>
                
                <h5>Supplementary Provisions</h5>
                <p>
                    - Effective Date: August 20, 2020<br>
                    - Revised: April 4, 2022<br>
                    - These Terms apply to all users as of April 4, 2022<br>
                </p>
                <br>
                
                <div class="extra">
                    <span class="title">Appendix 1. Scope of Web Services</span>
                    <p>- QESG Website: <a href="http://qesg.co.kr">http://qesg.co.kr</a> and subdomains</p>
                    <p>- QESG Assessment: <a href="http://assessment.qesg.co.kr">http://assessment.qesg.co.kr</a></p>
                    <p>- TierZero: <a href="http://tierzero.kr">http://tierzero.kr</a> and subdomains</p>
                    <p>- QESG Board: <a href="http://board.qesg.co.kr">http://board.qesg.co.kr</a></p>
                </div>
            </div>
        </template>

</div>
</template>

<script>
export default {}
</script>

<style scoped>
h3 {
    font-weight: bolder;
    line-height: 150%;
    word-break: keep-all;
    margin-bottom: 0.5rem;
}

h5 {
    font-weight: bolder;
    line-height: 150%;
    word-break: keep-all;
    margin-bottom: 0.5rem;
}

.terms-of-use-text {

}

p {
    font-weight: 300;
    font-size: 11pt;
    line-height: 150%;
    color: rgb(73, 73, 73);
    background: white;
}

.terms-of-use-details {
    font-weight: 300;
    font-size: 11pt;
    line-height: 150%;
    color: rgb(73, 73, 73);
    background: white;

    .sub-details {
        margin-left: 38px;
    }
    .sub-details2 {
        margin-left: 16px;
    }
}

table {
    margin-top: 12px;

    td {
        vertical-align: top;

    }
}
.extra {
    p {
        margin-top: 12px;
    }
} 
</style>
